/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {
    useEffect, useState,
} from 'react';
import { ClickAwayListener, Popper, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import {
    arrayOf, number, object, shape,
    string,
} from 'prop-types';
import PriceShownDetail from './PriceShownDetail';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles(() => ({
    container: {
        position: 'relative',
    },
    popperRoot: {
        zIndex: 9999,
    },
    priceShown: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
        letterSpacing: '0.12px',
        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'auto',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
        cursor: 'pointer',
        '@media only screen and (max-width: 768px)': {
            lineHeight: '16px !important',
            fontSize: '12px !important',
        },
    },
}));

const PriceShownUi = ({
    dynamicPriceData, skuPriceRange, partNumber,
}) => {
    if (!skuPriceRange) { return null; }
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();

    const openPriceDialog = (event) => {
        setAnchorEl(event?.currentTarget);
        setOpen(!isOpen);
        if (!isOpen) {
            dispatch(trackEvent({
                eventCategory: 'Collection',
                eventAction: 'Click',
                eventLabel: 'Price as shown',
                feature_detail: 'Price as shown',
                feature_element: 'Click',
                feature_category: 'Collection',
            }));
        }
    };

    useEffect(() => {
        if (typeof document !== 'undefined' && dynamicPriceData) {
            if (anchorEl) {
                document.body.setAttribute('style', 'overflow: hidden');
            } else {
                document.body.setAttribute('style', 'overflow');
            }
        }
    }, [anchorEl]);

    const productMessageCopyTitle = () => (
        <div role="presentation" aria-label="Click here to open popper" onClick={(e) => openPriceDialog(e)} className={classes.priceShown}>
            See price as shown
        </div>
    );

    return (
        <div className={`${classes.container} `}>
            {productMessageCopyTitle()}
            {isOpen
                ? (
                    <div className={classes.container}>
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            touchEvent="onTouchStart"
                            onClickAway={() => {
                                setOpen(false);
                                if (typeof document !== 'undefined') {
                                    document.body.removeAttribute('style', 'overflow');
                                }
                                setAnchorEl(null);
                            }}
                        >
                            <Popper
                                className={classes.popperRoot}
                                open={isOpen}
                                anchorEl={anchorEl}
                                transition
                                placement="bottom-start"
                            >
                                <PriceShownDetail
                                    openPriceDialog={openPriceDialog}
                                    showSinglePrice={false}
                                    skuPriceRange={skuPriceRange}
                                    partNumber={partNumber}
                                />
                            </Popper>
                        </ClickAwayListener>
                    </div>
                )
                : <></>}
        </div>

    );
};

PriceShownUi.propTypes = {
    dynamicPriceData: object.isRequired,
    partNumber: string.isRequired,
    skuPriceRange: shape({
        retail: arrayOf(shape({
            value: number,
        })),
        sale: arrayOf(shape({
            value: number,
        })),
    }),
};
PriceShownUi.defaultProps = {
    skuPriceRange: {},
};

export default PriceShownUi;
